import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import moment, { Moment } from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { AMControllerService } from "./dbcontroller/dbcontroller.service";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// pdfMake.fonts = {
//   // Default font should still be available
//   helvetica: {
//     normal: 'helvetica-light.ttf'
//   }
// }
@Injectable({
  providedIn: "root",
})
export class PrintService {
  isPrinting = false;
  routerUrl = "";
  NowPrintingEvent = new EventEmitter<number>();
  reportData: any = [];
  static instance: PrintService;

  constructor(
    private router: Router,
    public controllerService: AMControllerService
  ) {
    PrintService.instance = this;
  }

  public printReport(ledgerdata, rptinfo,printoption) {
    this.reportData = ledgerdata;

    var dd = {
      // Define page size, orientation, and margins
      pageSize: "A4",
      pageOrientation: "portrait",
      pageMargins: [20, 40, 20, 50],
      footer: function (currentPage, pageCount) {
        return { text: `Page ${currentPage} of ${pageCount}`, alignment: "center" };
      },
      // Define the content of the document
      content: [
        // Title section
        { text: rptinfo.compname, style: "header", color: "green", alignment: "left", margin: [0, 0, 0, 0] },
        { text: rptinfo.add, color: "green", alignment: "left", margin: [0, 0, 0, 5] },

        // Customer information section
        {
          columns: [
            { width: "60%", text: "A/C Statement of: " + rptinfo.acname,fontSize: 10, alignment: "left", bold: true, margin: [0, 0, 10, 0] },
            { width: "40%", color: "red", fontSize: 10, alignment: "right", text: "Period: " + rptinfo.period, margin: [10, 0, 0, 0] },
          ],
        },

        // Ledger table section
        {
          style: "normalText",
          table: {
            headerRows: 1,
            widths: [60, 35, 200, "*", "*", "*", 15],
            body: [
              // Table header
              [
                { fillColor: "#cccccc", alignment: "center", text: "Date" },
                { fillColor: "#cccccc", alignment: "center", text: "Vou No" },
                { fillColor: "#cccccc", alignment: "center", text: "Particulars" },
                { fillColor: "#cccccc", alignment: "center", text: "Debit" },
                { fillColor: "#cccccc", alignment: "center", text: "Credit" },
                { fillColor: "#cccccc", alignment: "center", text: "Balance" },
                { fillColor: "#cccccc", alignment: "center", text: "DC" },
              ],
              // { text: '2023-06-05', alignment: 'center', fontSize: 8 }
              ...this.reportData.map((item) => [
                { text: moment(item.voudt).format("DD/MMM/YYYY"), alignment: "center", fontSize: 8 },
                { text: item.vno, alignment: "center", fontSize: 8 },
                { text: item.narr, alignment: "left", fontSize: 7 },
                { text: item.debit > 0 ? item.debit.toFixed(2) : "", alignment: "right", fontSize: 8 },
                { text: item.credit > 0 ? item.credit.toFixed(2) : "", alignment: "right", fontSize: 8 },
                { text: (item.runningbal * -1).toFixed(2) , alignment: "right", fontSize: 8 },
                { text: item.runningbal > 0 ? "Dr" : "Cr", alignment: "center", fontSize: 8 },
              ]),
              [
                { fillColor: "#cccccc", alignment: "center", text: "" },
                { fillColor: "#cccccc", alignment: "center", text: "" },
                { fillColor: "#cccccc", alignment: "right", text: "Total" },
                { fillColor: "#cccccc", alignment: "right", text: this.reportData.map((t) => Number(t.debit)).reduce((acc, value) => acc + value, 0).toFixed(2) },
                { fillColor: "#cccccc", alignment: "right", text: this.reportData.map((t) => Number(t.credit)).reduce((acc, value) => acc + value, 0).toFixed(2) },
                { fillColor: "#cccccc", alignment: "right", text: ((this.reportData.map((t) => Number(t.debit)).reduce((acc, value) => acc + value, 0) - this.reportData.map((t) => Number(t.credit)).reduce((acc, value) => acc + value, 0)) * -1).toFixed(2) },
                { fillColor: "#cccccc", alignment: "center", text: ((this.reportData.map((t) => Number(t.debit)).reduce((acc, value) => acc + value, 0)) - (this.reportData.map((t) => Number(t.credit)).reduce((acc, value) => acc + value, 0))) > 0 ? "Dr" : "Cr" },
              ],
            ],
            lineWidth: 0.1,
          },

          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex % 2 === 0 ? "#ebebeb" : null;
            },
            hLineWidth: function (i, node) {
              return 0.1;
            },
            vLineWidth: function (i, node) {
              return 0.1;
            },
          },
          margin: [0, 20, 0, 20],
        },

      ],

      // Define custom styles
      styles: {
        header: { fontSize: 18, bold: true },
        boldText: { bold: true },
        normalText: { bold: false, fontSize: 10 },
      },
    };

    if(printoption == 0)
      pdfMake.createPdf(dd).print();
    else if(printoption == 1)
    PrintService.instance.getPDFMakeRefrence().createPdf(dd).download(rptinfo.acname+' ('+rptinfo.compname+ ').pdf');
    // this.getPDFMakeRefrence().pdfMake.createPdf(this.dd).open();
  }

  public getPDFMakeRefrence() {
    return pdfMake;
  }

}
